/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RefreshNftMetadataResponse
 */
export interface RefreshNftMetadataResponse {
    /**
     * 
     * @type {number}
     * @memberof RefreshNftMetadataResponse
     */
    refreshed: number;
    /**
     * 
     * @type {number}
     * @memberof RefreshNftMetadataResponse
     */
    missingMetadata: number;
}

/**
 * Check if a given object implements the RefreshNftMetadataResponse interface.
 */
export function instanceOfRefreshNftMetadataResponse(value: object): value is RefreshNftMetadataResponse {
    if (!('refreshed' in value) || value['refreshed'] === undefined) return false;
    if (!('missingMetadata' in value) || value['missingMetadata'] === undefined) return false;
    return true;
}

export function RefreshNftMetadataResponseFromJSON(json: any): RefreshNftMetadataResponse {
    return RefreshNftMetadataResponseFromJSONTyped(json, false);
}

export function RefreshNftMetadataResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): RefreshNftMetadataResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'refreshed': json['refreshed'],
        'missingMetadata': json['missingMetadata'],
    };
}

export function RefreshNftMetadataResponseToJSON(json: any): RefreshNftMetadataResponse {
    return RefreshNftMetadataResponseToJSONTyped(json, false);
}

export function RefreshNftMetadataResponseToJSONTyped(value?: RefreshNftMetadataResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'refreshed': value['refreshed'],
        'missingMetadata': value['missingMetadata'],
    };
}

